/*
----App内部H5跳转原生页面fun
----by lqx 2016/10/20
----参数参见svn文档-->H5跳转App指定页面规则汇总.xls by zwx

action 新方法默认为9
p：package包（字符型）；
c：class类名（字符型）.


*/
import util, { JudgeBrowser } from './util';

export default function jumpInApp(options) {
  console.log(util.isApp())
  if (!util.isApp()) {
    return false;
  }
  var defaults = {
    action: 9,
    case: 0,
    title: '热门活动',
    url: '',
    productID: '', //产品ID
    backText: '',
    backUrl: '', // backUrl传参语法！代替？；-代替=；$代替&
    hasShare: 0,
  };
  var param = '';
  var opts = Object.assign({}, defaults, options);
  var ourl = opts.url;
  var otitle = opts.title;
  var obank = opts.bank;
  var oitemId = opts.itemId;
  var oproductID = opts.productID;
  var oaccountNum = opts.accountNum;
  var opurchased = opts.purchased;
  var ocase = opts.case;
  var getFlag = JudgeBrowser;
  var flag = getFlag.flag; // lag为1是ios，flag为2是安卓
  var orderNo = opts.orderNo;
  if (opts.action == 1) {
    // 显示 分享 微信和朋友圈
    param =
      '&title=' +
      otitle +
      '&content=' +
      opts.content +
      '&hasShare=' +
      opts.hasShare +
      '&url=' +
      ourl +
      '&shareType=' +
      opts.shareType +
      '&imgUrl=' +
      opts.imgUrl;
    //hasShare 1分享后有回调 0分享后无回调  回调从url判断有无shareSuccess
    //shareType “image” “text”提供分享类型
  } else if (opts.action == 0) {
    //关闭页面
  } else if (opts.action == 2) {
    //分享邀请好友
  } else if (opts.action == 3) {
    //显示右上角分享按钮
    param =
      '&title=' +
      otitle +
      '&content=' +
      opts.content +
      '&hasShare=' +
      opts.hasShare +
      '&url=' +
      ourl +
      '&imgUrl=' +
      opts.imgUrl;
  } else if (opts.action == 40) {
    //隐藏右上角分享按钮
  } else if (opts.action == 42) {
    //保存到相册
    param = '&imgUrl=' + opts.imgUrl;
  } else if (opts.action == 100) {
    //返回 是否直接退出 0退出 1返回上一页
    param = '&RT=' + opts.RT;
  } else if (opts.action == 43) {
    //唤醒支付宝支付
    param = '&projectId=' + opts.projectId + '&totalFee=' + opts.totalFee;
  } else if (opts.action == 20) {
    // 拨打电话
    param = ""
  } else if (opts.action == 21) {
    // 联系客服
    param = ""
  } else if (opts.action == 50) {
    // 充值、购买成功跳空白页
    param= "&orderNo="+ orderNo
  }
  
  var mainBoard = '&storyBoardName=Main&className=';
  if (flag == 1) {
    if (opts.action == 9) {
      switch (ocase) {
        case 1:
          param = mainBoard + 'MainTab&tabId=0';
          break; //----首页
        case 2:
          param = mainBoard + 'MainTab&tabId=1&tabListId=1';
          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----理财(产品列表)
        case 3:
          param = mainBoard + 'MainTab&tabId=3';
          break; //----钱包
        case 4:
          param = mainBoard + 'MainTab&tabId=4';
          break; //----我的
        case 5:
          param = mainBoard + 'SignInViewController';
          break; //----签到有礼
        case 6:
          param = mainBoard + 'QRCodeViewController2';
          break; //----邀请好友/二维码邀请

        case 7:
          param = mainBoard + 'AnnoucementListViewController';
          break; //----平台公告
        case 8:
          param = mainBoard + 'DiscountTiketViewController';
          break; //----优惠券
        case 9:
          param =
            mainBoard +
            'WebViewController&currentNaviTitle=' +
            otitle +
            '&URL_HTML=' +
            ourl;
          break; //----热门活动
        /*  url:活动的链接（字符串），注意URL中不能包含"?"号，
          例如：https://www.huaqiaobao.cn/view/app/activity.html*/

        case 10:
          param = mainBoard + 'ItemDetailViewController&itemID=' + oproductID;
          break; //----理财产品（产品内容）
        // case 11 : param = '&p=2&c=ProductDetails&id='+ oproductID ;          //----产品详情
        case 11:
          param =
            mainBoard +
            'InvestViewController&webProductID=' +
            oproductID +
            '&webInvestMoney=' +
            opts.oneedTender +
            '&backUrl=' +
            opts.backUrl +
            '&backText=' +
            opts.backText;
          if (opts.preOrder) {
            param = param + '&preOrder=' + opts.preOrder;
          }
          break; //投资确认页  backUrl:投资完成后返回页面 backText:返回按钮文案 preOrder:订单号
        case 12:
          param =
            mainBoard +
            'WebViewController&currentNaviTitle=银行限额&URL_HTML=https://www.huaqiaobao.cn/view/bank/limit.html';
          break; //----支持银行/银行限额详情

        case 13:
          param = mainBoard + 'TotalAssetsInfoViewController';
          break; //----我的总资产
        case 14:
          param = mainBoard + 'UseableMoneyTableViewController';
          break; //----可用余额
        case 15:
          param = mainBoard + 'ChargeViewController';
          break; //----充值
        case 16:
          param = mainBoard + 'InvestRecordViewController';
          break; //----我的投资/我的投资列表
        case 17:
          param = mainBoard + 'MyBankCardViewController';
          break; //----银行卡/我的银行卡
        case 18:
          param = mainBoard + 'DiscountTiketViewController';
          break; //----优惠券
        case 19:
          param = mainBoard + 'FriendIncomInfoViewController';
          break; //----邀请好友/推荐好友
        case 20:
          param = mainBoard + 'WithDrawViewController';
          break; //----提现
        case 21:
          param = mainBoard + 'AddBankCardViewController';
          break; //----绑定银行卡/添加银行卡/实名认证
        case 22:
          param = mainBoard + 'FriendIncomInfoViewController';
          break; //----推荐好友下立即邀请
        case 23:
          param = mainBoard + 'FriendRecordViewController';
          break; //----查看记录/查看邀请好友记录
        //  case 25 : param = mainBoard+'WebViewController&title=奖励规则&URL_HTML=https://www.huaqiaobao.cn/view/app/invite.html';     //----奖励规则

        case 24:
          param = mainBoard + 'MemberID&showedByWeb=1';
          break; //----我的会员
        case 25:
          param = mainBoard + 'UserSettingsViewController';
          break; //----用户设置
        case 26:
          param = mainBoard + 'HelpListViewController';
          break; //----帮助中心
        case 27:
          param = mainBoard + 'ContactUsViewController';
          break; //----联系我们
        case 28:
          param = '&storyBoardName=Debunk&className=DebunkVCID';
          break; //----吐槽我们
        case 29:
          param = mainBoard + 'AboutUsViewController2';
          break; //----关于华侨宝
        case 30:
          param = mainBoard + 'HelpTableVCID&code=about_vip&isPushVipInfo=1';
          break; //----会员说明/查看全部特权
        case 31:
          param = mainBoard + 'HasAddressViewController&showedByWeb=1';
          break; //----查看收货地址
        case 32:
          param = mainBoard + 'ResetPayPWDViewController';
          break; //----修改账户密码

        case 33:
          param = '&storyBoardName=Register';
          break; //----注册
        case 34:
          param = '&storyBoardName=Login';
          break; //----登录
        case 36:
          param =
            '&storyBoardName=Discovery&className=TaskCenterViewController';
          break; //----任务中心
        // case 35 : param = '&p=5&c=ForgetPwd';         //----忘记密码/找回密码
        case 37:
          param = mainBoard + 'MainTab&tabId=2';
          break; //----发现
        case 38:
          param = '&storyBoardName=Main&className=PreAddBankViewController';
          break; //----跳开户
        case 40:
          param =
            mainBoard +
            'MainTab&tabId=1&tabListId=0&userSelectedGoldTimeLimit=' +
            (opts.goldTimeLimit || 30); //userSelectedGoldTimeLimit   黄金投资期限

          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----理财(产品列表) 黄金
        case 41:
          param =
            '&storyBoardName=Main&className=BuyStableGoldViewController' +
            '&limitRateId=' +
            opts.limitRateId +
            '&backUrl=' +
            (opts.backUrl || '') +
            '&backText=' +
            (opts.backText || '');
          if (opts.preOrder) {
            param = param + '&preOrder=' + opts.preOrder;
          }
          break; //----黄金购买页 goldGram克数 skuId  产品ID  limitRateId 存储期限id
        case 42:
          param =
            '&storyBoardName=Main&className=UseableMoneyTableViewController';
          break; //----跳存管账户余额页
        case 43:
          param = mainBoard + 'ItemListViewController'; //   侨行天下黄金投资期限

          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----侨行天下理财(产品列表) 黄金
        case 44:
          param = mainBoard + 'MyPointViewController';
          break; //----积分记录页
        case 45:
          param = '&storyBoardName=v4';
          break; //----跳V4列表页
        case 46:
          param = '&storyBoardName=v5';
          break; //----跳V5列表页
        case 47:
          param = '&storyBoardName=AuctionDetail&itemId=' + oitemId;
          break; //----跳拍卖商品详情页
          case 48:
            param = "&storyBoardName=Goods&className=GoodsDetailViewController&itemId=" + oitemId;
            break; //----跳商品详情页
        case 49:
          param =
            '&storyBoardName=OtherViewController&className=HomeMainSecKillMainViewController&seckillSessionId=' +
            oitemId;
          break; //----跳秒杀列表
        case 50:
          param =
            '&storyBoardName=OtherViewController&className=HomeRechargeMainViewController';
          break; //----跳话费油卡充值
        case 51:
          param =
            '&storyBoardName=OtherViewController&className=HomeLifeMainViewController&firstCategoryId=' +
            oitemId;
          break; //----视频会员商品列表页
        case 52:
          param =
            '&storyBoardName=Goods&className=OrderListViewController&segmentSelectIndex=2&isBuyGoodsSuccess=YES';
          break; //----商品订单列表页
        case 53:
          param = mainBoard + 'GoldWalletViewController';
          break; //----黄金钱包
      }
    }
    window.location.href = 'hqb://location?action=' + opts.action + param;
  } else {
    if (opts.action == 9) {
      switch (ocase) {
        case 1:
          param = '&p=0&c=MainTab&tabId=0';
          break; //----首页
        case 2:
          param = '&p=0&c=MainTab&tabId=1&tabListId=1';
          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----理财(产品列表)
        case 3:
          param = '&p=0&c=MainTab&tabId=3';
          break; //----钱包
        case 4:
          param = '&p=0&c=MainTab&tabId=4';
          break; //----我的
        case 5:
          param = '&p=1&c=SignIn';
          break; //----签到有礼
        case 6:
          param = '&p=3&c=FriendRecommend';
          break; //----邀请好友/二维码邀请

        case 7:
          param = '&p=4&c=Notices';
          break; //----平台公告
        case 8:
          param = '&p=3&c=Coupons';
          break; //----优惠券
        case 9:
          param =
            '&p=5&c=WebView&showOrHide=true&title=' + otitle + '&url=' + ourl;
          break; //----热门活动
        /*  url:活动的链接（字符串），注意URL中不能包含"?"号，
          例如：https://www.huaqiaobao.cn/view/app/activity.html*/

        case 10:
          param = '&p=2&c=InvestDetails&id=' + oproductID;
          break; //----理财产品（产品内容）
        case 11:
          param =
            '&p=2&c=ToInvest&id=' +
            oproductID +
            '&oneedTender=' +
            opts.oneedTender +
            '&backUrl=' +
            opts.backUrl +
            '&backText=' +
            opts.backText;
          if (opts.preOrder) {
            param = param + '&preOrder=' + opts.preOrder;
          }
          break;
        // case 11 : param = '&p=2&c=ProductDetails&id='+ oproductID ;  break;        //----产品详情

        case 12:
          param =
            '&p=5&c=WebView&title=支持银行&url=https://www.huaqiaobao.cn/view/bank/limit.html';
          break;
        //----支持银行/银行限额详情

        case 13:
          param = '&p=3&c=TotalAsset';
          break; //----我的总资产
        case 14:
          param = '&p=3&c=AvailableBalance';
          break; //----可用余额
        case 15:
          param = '&p=3&c=Recharge';
          break; //----充值
        case 16:
          param = '&p=3&c=InvestmentRecord';
          break; //----我的投资/我的投资列表
        case 17:
          param = '&p=3&c=BankList';
          break; //----银行卡/我的银行卡
        case 18:
          param = '&p=3&c=Coupons';
          break; //----优惠券
        case 19:
          param = '&p=3&c=FriendInvite';
          break; //----邀请好友/推荐好友
        case 20:
          param = '&p=3&c=Withdraw';
          break; //----提现
        case 21:
          param = '&p=3&c=BankList';
          break; //----绑定银行卡/添加银行卡/实名认证
        case 22:
          param = '&p=3&c=FriendRecommend';
          break; //----推荐好友下立即邀请
        case 23:
          param = '&p=3&c=FriendRecord';
          break; //----查看记录/查看邀请好友记录
        //  case 25 : param = '&p=5&c=WebView&title=''&url=https://www.huaqiaobao.cn/view/app/invite.html';     //----奖励规则

        case 24:
          param = '&p=4&c=Membership';
          break; //----我的会员
        case 25:
          param = '&p=4&c=Setting';
          break; //----用户设置
        case 26:
          param = '&p=4&c=HelpCenter';
          break; //----帮助中心
        case 27:
          param = '&p=4&c=Contact';
          break; //----联系我们
        case 28:
          param = '&p=4&c=Feedback';
          break; //----吐槽我们
        case 29:
          param =
            '&p=5&c=WebView&title=关于华侨宝&url=https://www.huaqiaobao.cn/view/app/aboutUs.html';
          break; //----关于华侨宝
        case 30:
          param = '&p=4&c=HelpDetails&title=会员说明&code=about_vip';
          break; //----会员说明/查看全部特权
        case 31:
          param = '&p=4&c=AddressList';
          break; //----查看收货地址
        case 32:
          param = '&p=4&c=ModifyPwd';
          break; //----修改账户密码

        case 33:
          param = '&p=5&c=Register';
          break; //----注册
        case 34:
          if (opts.backUrl) {
            // backUrl #后面参数  如 #/detail/1
            opts.action = 5;
            param = '&loginBackUrl=' + opts.backUrl;
          } else {
            param = '&p=5&c=Login&tabId=-1';
          }
          break; //----登录
        case 35:
          param = '&p=5&c=ForgetPwd';
          break; //----忘记密码/找回密码
        case 36:
          param = '&p=6&c=TaskCenter';
          break; //----任务中心
        case 37:
          param = '&p=0&c=MainTab&tabId=2';
          break; //----发现
        case 38:
          param = '&p=3&c=AddBank';
          break; //开户
        case 40:
          param =
            '&p=0&c=MainTab&tabId=1&tabListId=0&goldTimeLimit=' +
            (opts.goldTimeLimit || 30); //---goldTimeLimit 黄金产品期限
          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----理财(产品列表) 黄金
        case 41:
          param =
            '&p=7&c=ToBuyStableGold&limitRateId=' +
            opts.limitRateId +
            '&backUrl=' +
            opts.backUrl +
            '&backText=' +
            opts.backText;
          if (opts.preOrder) {
            param = param + '&preOrder=' + opts.preOrder;
          }
          break; //----黄金购买页  goldGram 克数 skuId  产品ID  limitRateId 存储期限id
        case 42:
          param = '&p=3&c=TradeRecord';
          break; //----跳存管账户余额页
        case 43:
          param = '&p=7&c=GoldList';
          if (opts.backUrl) {
            param += '&backUrl=' + opts.backUrl + '&backText=' + opts.backText;
          }
          break; //----理财(产品列表) 黄金
        case 44:
          param = '&p=3&c=MyPoint';
          break; //----积分记录页
        case 45:
          param = '&p=2&c=ProductList&vipRank=4';
          break; //----跳V4列表页
        case 46:
          param = '&p=2&c=ProductList&vipRank=5';
          break; //----跳V5列表页
        case 47:
          param = '&p=2&c=AuctionDetail&itemId=' + oitemId;
          break; //----跳拍卖商品详情页
        case 48:
          param = '&p=2&c=ProductDetail&itemId=' + oitemId;
          break; //----跳商品详情页
        case 49:
          param = '&p=2&c=ProductList&vipRank=5' + oitemId;
          break; //----跳秒杀列表
        case 50:
          param = '&p=2&c=ProductList&vipRank=5';
          break; //----跳话费油卡充值
        case 51:
          param = '&p=2&c=ProductList&vipRank=5' + oitemId;
          break; //----视频会员商品列表页
        case 52:
          param = '&p=2&c=ProductOrder&orderStatus=3';
          break; //----商品订单列表页
        case 53:
          param = '&p=7&c=GoldWallet';
          break; //----黄金钱包
      }
    }
    if (window.WebJavascript) {
      window.WebJavascript.clickCenter(opts.action, param);
    }
  }
}
